import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import Analytics from 'analytics-opencare';
import { Subtitle, Title } from 'pages/common/styled-components';
import { StepWrapper } from 'pages/funnel/styled-components';
import { useAnalyticsService } from 'services/AnalyticsService';
import sanitizeString from 'utils/sanitizeString';

import { useFunnelStorage } from '../../storage/Storage';
import { generateStepAnalytics, STEP_KEY } from '../../utils';

import { getTreatmentIndex } from './constants';
import { TreatmentSelector } from './TreatmentSelector';

const analytics = new Analytics();

const ConcernsTreatment = ({ position, moveToNextStep }) => {
  const storage = useFunnelStorage();

  const analyticsService = useAnalyticsService();

  const savedTreatments = storage.get(STEP_KEY.CONCERNS_TREATMENT)?.concernsTreatments;
  const isOngoingSelected = storage.get(STEP_KEY.ONGOING_CARE)?.ongoingCare === 'Yes';

  useEffect(() => {
    analytics.trackPageView({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_concerns',
      ...generateStepAnalytics(position, storage),
      ...analyticsService.analyticsData,
    });
  }, []);

  const goToNextStep = ({ selectedTreatments, otherTreatmentDescription }) => {
    const data = { concernsTreatment: selectedTreatments };

    analytics.trackClick({
      pageType: analytics.pageTypes.FUNNEL,
      pageName: 'funnel_concerns-treatment',
      name: 'wizard',
      section: 'concerns-treatment',

      position: selectedTreatments.map(treatment =>
        getTreatmentIndex(treatment.id)),
      ...generateStepAnalytics(position, storage, {
        response:
          selectedTreatments.map(treatment => treatment.title).join(',')
          + (otherTreatmentDescription ? `,${sanitizeString(otherTreatmentDescription)}` : ''),
      }),
    });

    storage.save(STEP_KEY.CONCERNS_TREATMENT, data, true);

    moveToNextStep();
  };

  return (
    <div data-testid="main-reason">
      <Title id="title">
        Do you have any specific concerns or treatments you require?
      </Title>
      <Subtitle>
        We will ensure we match you with a dentist who has expertise in these
        areas, and provide them the information.
      </Subtitle>
      <StepWrapper>
        <TreatmentSelector
          savedTreatments={savedTreatments}
          isOngoingSelected={isOngoingSelected}
          onContinue={goToNextStep}
        />

      </StepWrapper>
    </div>
  );
};

ConcernsTreatment.propTypes = {
  position: PropTypes.string,
  moveToNextStep: PropTypes.func.isRequired,
};

export default ConcernsTreatment;
